import React from 'react'
import { Switch } from 'antd';

import modStyl from './index.module.scss'

interface SwitchGroupProps {
  isOpenCode: boolean
  onChange: (checked: boolean)=> void
  onMarkChange: (checked: boolean)=> void
}
const SwitchGroup: React.FC<SwitchGroupProps> = ({ isOpenCode, onChange, onMarkChange })=> {
  return (
    <div className={modStyl.wrapper}>
      <div className={modStyl.item}>
        <span>打码模式</span>
        <Switch checked={isOpenCode} onChange={onChange} defaultChecked={true} size="small"/>
      </div>
      <div className={modStyl.item}>
        <span>高亮</span>
        <Switch disabled={isOpenCode} onChange={onMarkChange} defaultChecked={true} size="small"/>
      </div>
    </div>
  )
}

export default SwitchGroup
